// import { storage } from 'APP/packages/storage';
import { COUNTRIES } from 'APP/constants/countryCodes';
import { ICountryCodes } from 'APP/types/countryCodes';
import Entities from 'STORE';

export const getCountriesPhoneCodes = async (force = false): Promise<ICountryCodes> => {
  // GEM-31801, вернуть логику когда список countries будем получать по api

  // const localStorageCountryCodes = storage.countriesPhoneCodes.get();
  // const isAppVersionDifferent = Entities.App.version !== localStorageCountryCodes?.appVersion;

  // let currentCountry: ICountry;
  // let availableCounties: ICountry[];

  // if (!localStorageCountryCodes || isAppVersionDifferent || force) {
  // const serverCountryCodes = (await api.authorization.getCountriesPhoneCode()) as ICountryCodes;

  // storage.countriesPhoneCodes.set({
  //   appVersion: Entities.App.version,
  //   ...countryCodes,
  // });

  // currentCountry = serverCountryCodes.currentCountry;
  // availableCounties = serverCountryCodes.availableCounties;
  // } else {
  //   currentCountry = localStorageCountryCodes.currentCountry;
  //   availableCounties = localStorageCountryCodes.availableCounties;
  // }

  const countryCodes: ICountryCodes = {
    availableCounties: COUNTRIES,
    currentCountry: {
      countryCode: 'RU',
      countryName: 'Россия',
      phonePrefix: '+7',
      phoneTemplate: '+X XXX XXX-XX-XX',
      flag: '🇷🇺',
    },
  };

  Entities.App.setAvailableCountries(countryCodes.availableCounties);

  return countryCodes;
};
